<template>
  <content-panel>
    <template v-slot:search>
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="100px" :model="searchForm" :rules="rules" ref="searchForm">
          <el-form-item label="产品编码">
            <el-input v-model.trim="searchForm.productCode" @keyup.enter.native="onSearch" />
          </el-form-item>
          <el-form-item label="产品名称">
            <el-input v-model.trim="searchForm.productName" @keyup.enter.native="onSearch" />
          </el-form-item>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
        <el-button type="primary" size="small" @click="importExcel">导入</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column prop="productCode" label="产品编码"></el-table-column>
        <el-table-column prop="productName" label="产品名称"></el-table-column>
        <el-table-column prop="batchNum" label="首批量"></el-table-column>
        <el-table-column prop="" label="操作" width="120" align="center">
          <template slot-scope="{row}">
            <el-button type="text" size="mini" @click="edit(row)">编辑</el-button>
            <el-button type="text" size="mini" style="color: red" @click="del(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <!-- 首批量 -->
    <first-batch v-model="firstBatchVisible" :data="rowData" v-if="firstBatchVisible" @success="onSearch"></first-batch>
  </content-panel>
</template>

<script>
import firstBatch from './firstBatch'
import pagePathMixin from '@/utils/page-path-mixin'
import tableMixin from "@/utils/tableMixin";
import axios from "@/utils/axiosInstance";
import { downloadFile } from "@/utils";
import moment from "moment";
export default {
  name: "photographySalaryAccounting",
  mixins: [tableMixin, pagePathMixin],
  components: { firstBatch },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      reportName: "productFirstBatchInfo",
      columnData: [],
      loading: false,
      searchForm: {
        productTypes: "",
        spuCategory: "",
        goodsLocation: "",
      },
      exportData: {},
      searchCollapse: false,
      queryCriteria: [],
      spuCategoryList: [],
      goodsLocationList: [],
      productTypeList: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
      firstBatchVisible: false,
      rowData: {}
    };
  },
  computed: {},
  methods: {
    onSearch() {
      this.$refs.tableRef.clearSelection();
      this.tableData.pageNum = 1;
      this.queryCriteria = [
        {
          attributeName: "productCode", //产品编码
          val: this.searchForm.productCode ? this.searchForm.productCode : "",
          op: "like",
        },
        {
          attributeName: "productName", //产品名称
          val: this.searchForm.productName ? this.searchForm.productName : "",
          op: "like",
        },
      ];
      this.init();
    },
    async init(type) {
      this.loading = true;
      let filter = this.queryCriteria.filter((item) => item.val.length && item.val[0]);
      let data = {
        pageSize: this.tableData.pageSize,
        pageNum: this.tableData.pageNum,
        reportCode: this.reportName,
        param: {},
        queryMatch: filter || [],
        orderList: [],
        orderByColumn: "",
        orderType: "",
        hasCount: "Y",
      };
      if (type) {
        data.queryMatch = type.queryMatch;
        data.orderList = type.orderList;
      }
      this.searchFormData = data;
      axios
        .post(`/ec-pc-api/custom/reports/data/${this.reportName}`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            if (!type) {
              this.tableReload = false;
              this.$nextTick((_) => {
                this.tableReload = true;
              });
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },

    reset() {
      if (this.$refs["table"]) {
        this.$refs["table"].clearSort(); //切换清除排序
      }
      this.searchForm = {
        productTypes: "",
        spuCategory: "",
        goodsLocation: "",
      };
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    edit(row) {
      this.rowData = {...row}
      this.firstBatchVisible = true
    },
    async del(row) {
      let status = await this.$confirm("是否确认删除该条数据？",'提示', {type: 'warning'});
      if(status !== 'confirm') return ;
      let res = await this.$q.preSalePlan.firstBatchDel({fragment: [row.dataId]})
      if(res.success) {
        this.$message.success('删除成功')
      }else{
        this.$message.fail('删除失败')
      }
      this.onSearch();
    },

    //导入
    importExcel() {
      this.openSubPage({
        path: "/firstBatch",
        query: {
          fileName: "新品首批库导入.xlsx",
          appCode: "ec-pc-new",
        },
      });
    },

    // 导出
    exportExcel() {
      console.log(this.searchFormData)
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let params = {
        appCode: 'ec-pc-new',
        // paramMap: this.searchFormData.filterData,
        paramMap: {
          ...this.searchFormData
        },
        reportName: this.reportName
      }
      this.$q.common.exportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！')
          loading.close()
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "--";
        }
      }
    },
  },
  mounted() {
    this.onSearch();
  },
};
</script>

<style lang="stylus" scoped></style>
